package com.dotdrives.web.pages.updates

import com.dotdrives.controller.GivingSummaryController
import com.dotdrives.repository.SupabaseGivingSummaryRepository
import com.dotdrives.web.shell.NavItem
import com.dotdrives.web.shell.PortalShell
import com.dotdrives.web.ui.useFlowState
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.awaitCancellation
import kotlinx.coroutines.cancel
import react.FC
import react.Props
import react.useEffect
import react.useState
import kotlin.time.Clock
import com.dotdrives.model.*
import kotlinx.datetime.LocalDate

private class ReportsHolder(val scope:kotlinx.coroutines.CoroutineScope,val controller:GivingSummaryController,val initialUrl:ReportUrlState)
external interface ReportsPortalProps:Props {
    var currentUserRole:String; var orgId:String; var fiscalStartMonth:Int; var fiscalStartDay:Int
    var userInitials:String; var userName:String; var orgName:String
    var onSwitchOrg:()->Unit; var onNavigate:(NavItem)->Unit; var onSignOut:()->Unit
}

val ReportsPortal=FC<ReportsPortalProps> { props ->
    val currentFiscalYear=currentReportFiscalYear(LocalDate.parse(kotlin.js.Date().toISOString().take(10)),props.fiscalStartMonth,props.fiscalStartDay)
    val (holder)=useState {
        val scope=MainScope(); val initial=parseReportUrl(kotlinx.browser.window.location.hash,currentFiscalYear)
        ReportsHolder(scope,GivingSummaryController(SupabaseGivingSummaryRepository(),scope,props.orgId,props.currentUserRole=="field",initial.year,props.fiscalStartMonth,props.fiscalStartDay),initial)
    }
    val state=useFlowState(holder.controller.state)
    useEffect(holder) {
        val parsed=holder.initialUrl
        val customValid=parsed.period.equals("custom",true)&&runCatching { customReportPeriod(LocalDate.parse(parsed.start!!),LocalDate.parse(parsed.end!!)) }.isSuccess
        val kind=when { parsed.period.lowercase() in listOf("rollingtwelve","rolling") -> ReportPeriodKind.RollingTwelve; customValid -> ReportPeriodKind.Custom; else -> ReportPeriodKind.FiscalYear }
        val today=LocalDate.parse(kotlin.js.Date().toISOString().take(10))
        val period=resolveReportPeriod(parsed,today,props.fiscalStartMonth,props.fiscalStartDay)
        holder.controller.setFilter(ReportFilter(period,kind,parsed.target,parsed.steward),parsed.year)
        try { awaitCancellation() } finally { holder.scope.cancel() }
    }
    PortalShell {
        active=NavItem.Reports; onNavigate=props.onNavigate; userInitials=props.userInitials; userName=props.userName; orgName=props.orgName
        onSwitchOrg=props.onSwitchOrg; onSignOut=props.onSignOut
        UpdatesStyles()
        ReportsPage { this.currentFiscalYear=currentFiscalYear; controller=holder.controller; this.state=state; availableTargets=state.targetCatalog; availableStewards=state.stewardCatalog }
    }
}
